import React from 'react';
import { FC } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import {
  // createMuiTheme,
  jssPreset,
  // MuiThemeProvider,
  StylesProvider
  // ThemeProvider
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import GlobalStyles from 'src/components/GlobalStyles';
import ScrollReset from 'src/components/ScrollReset';
import AuthProvider from 'src/contexts/authContext';
// import useSettings from 'src/hooks/useSettings';
// import { createTheme } from 'src/theme';
import routes, { renderRoutes } from 'src/routes';
import RouteChangeTracker from './RouteChangeTracker';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const history = createBrowserHistory();

const App: FC = () => {
  // const { settings } = useSettings();

  // const theme = createTheme({
  //   direction: settings.direction,
  //   responsiveFontSizes: settings.responsiveFontSizes,
  //   theme: settings.theme
  // });

  // const muiTheme = createMuiTheme({
  //   palette: {
  //     primary: {
  //       main: '#000000'
  //     },
  //     secondary: {
  //       main: '#ba000d'
  //     }
  //   }
  // });

  return (
    // <ThemeProvider theme={theme}>
    // <MuiThemeProvider theme={muiTheme}>
    <StylesProvider jss={jss}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Router history={history}>
          <RouteChangeTracker />
          <AuthProvider>
            <GlobalStyles />
            <ScrollReset />
            {renderRoutes(routes)}
          </AuthProvider>
        </Router>
      </MuiPickersUtilsProvider>
    </StylesProvider>
    // </MuiThemeProvider>
    // </ThemeProvider>
  );
};

export default App;
